import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSofa = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.75 9.375C21.3522 9.375 20.9706 9.53304 20.6893 9.81434C20.408 10.0956 20.25 10.4772 20.25 10.875V12.375C20.25 12.5739 20.171 12.7647 20.0303 12.9053C19.8897 13.046 19.6989 13.125 19.5 13.125H4.5C4.30109 13.125 4.11032 13.046 3.96967 12.9053C3.82902 12.7647 3.75 12.5739 3.75 12.375V10.875C3.75 10.4772 3.59196 10.0956 3.31066 9.81434C3.02936 9.53304 2.64782 9.375 2.25 9.375C1.85218 9.375 1.47064 9.53304 1.18934 9.81434C0.908035 10.0956 0.75 10.4772 0.75 10.875V13.875C0.75 14.6706 1.06607 15.4337 1.62868 15.9963C2.19129 16.5589 2.95435 16.875 3.75 16.875H20.25C21.0456 16.875 21.8087 16.5589 22.3713 15.9963C22.9339 15.4337 23.25 14.6706 23.25 13.875V10.875C23.25 10.4772 23.092 10.0956 22.8107 9.81434C22.5294 9.53304 22.1478 9.375 21.75 9.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 16.875V19.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.25 16.875V19.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 9.375C2.25 8.18153 2.72411 7.03693 3.56802 6.19302C4.41193 5.34911 5.55653 4.875 6.75 4.875H17.25C18.4435 4.875 19.5881 5.34911 20.432 6.19302C21.2759 7.03693 21.75 8.18153 21.75 9.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.125V4.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSofa.displayName = 'SvgSofa';
export default SvgSofa;
